import React, { useEffect, } from "react"
import { useParams, withRouter } from "react-router-dom"
import { useSelector, connect, useDispatch } from "react-redux"
import {
    Row,
    Col,
    UncontrolledTooltip,
    Table,

} from "reactstrap"
//import * as quotationAction from "../../store/cXVvdGF0/actions"
import * as ecFollowupAction from "../../store/b3BlcmF0aW9uc0/actions"
import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import moment from "moment"

// import Modal from "react-bootstrap/Modal"

const OperationsEcFollowup = () => {
    const specificDispatch = useDispatch()

    let { id } = useParams()



    useEffect(() => {
        specificDispatch(ecFollowupAction.loadEcFollowupList(id))
    }, [])

    const ecUpdate = useSelector((state) => state.operationsFollowUp)
    const { ec_followup_list } = ecUpdate

    return (
        <React.Fragment>
            <Row className="quote-head-content">
                <Col lg="9" md="9" sm="6" xs="6" className="d-flex flex-row">
                    <p className="quote-head">
                        EC Followup
                        <span className="quote-info">
                            <i
                                style={{ color: "grey" }}
                                id="quoteInfo1"
                                aria-hidden="true"
                                className="fa fa-info-circle ms-1"
                            ></i>
                            <UncontrolledTooltip placement="right" target="quoteInfo1">
                                EC Followup
                            </UncontrolledTooltip>
                        </span>
                    </p>

                </Col>
            </Row>
            <Row>
                <Col className="mt-3">
                    <Table bordered responsive>
                        <thead style={{ backgroundColor: "#f9f9f9" }}>
                            <tr>
                                <th>S.No</th>
                                <th>Follow-up No</th>
                                <th>Followup Date</th>
                                <th>Time</th>
                                <th>Mode</th>
                                <th>Reach Status</th>
                                <th>Followup Reason</th>
                                <th>Attachment</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!isEmpty(ec_followup_list) && ec_followup_list.length > 0 ? (
                                ec_followup_list.map((followup, index) => {
                                    console.log(followup, "followup")
                                    var attachments = !isEmpty(followup.attachment)
                                        ? followup.attachment.map((f) => f)
                                        : []


                                    return (
                                        <>
                                            <tr key={index}>
                                                <td>

                                                    {index + 1}
                                                </td>
                                              
                                                <td>
                                                    {!isEmpty(followup) && followup.followupNumber
                                                        ? followup.followupNumber
                                                        : ""}
                                                </td>
                                                <td>
                                                    {!isEmpty(followup) && followup.followupDate
                                                        ? moment(followup.followupDate).format("DD-MM-YYYY")
                                                        : ""}
                                                </td>
                                                <td>
                                                    {!isEmpty(followup) && followup.time
                                                        ? followup.time
                                                        : ""}
                                                </td>
                                                <td>
                                                    {!isEmpty(followup.followupMode)
                                                        ? followup.followupMode.followupMaster
                                                        : "--"}
                                                </td>
                                                <td>{followup.reachStatus}</td>
                                                <td>
                                                    {!isEmpty(followup.followupReason)
                                                        ? followup.followupReason.followupReason
                                                        : ""}
                                                </td>
                                                <td>
                                                    <a onClick={() => window.open(attachments, "_blank")}>
                                                        <span
                                                            style={{
                                                                textDecoration: "underline",
                                                                color: "#E40D8C",
                                                            }}
                                                        >
                                                            View
                                                        </span>
                                                    </a>
                                                </td>
                                            </tr>
                                        </>
                                    )
                                })
                            ) : (
                                <>
                                    <tr key={0}>
                                        <td colSpan={9} className="text-align-center">
                                            No record found
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>

        </React.Fragment>
    )
}

OperationsEcFollowup.propTypes = {
    dispatch: PropTypes.func,
    clientProfile: PropTypes.array,
    location: PropTypes.array,
    modeMenu: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}

const mapStateToProps = () => ({
    //mapstate to props
})

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(OperationsEcFollowup)
)
